import {
  Link,
  Text,
} from '@fluentui/react';

export const TenantSubscriptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  padding-top: 32px;
  padding-bottom: 16px;
  padding-left: 24px;
  padding-right: 24px;
`;

export const TemporaryNotesContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin-top: -16px;
`;

export const SingleTenantContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  align-items: space-between;
`;

export const TenantTextIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 548px;
`;

export const TenantDivider = styled.div`
  border: 1px solid #e5e5e5;
  width: 548px;
`;

export const TenantText = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #323130;
`;

export const CdmSubscriptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  padding-top: 32px;
  padding-bottom: 32px;
`;

export const CdmHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
`;

export const CdmText = styled(Text)`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  box-shadow: #171717;
`;

export const SelectAllText = styled(Link)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #0064bf;
`;

export const AttributeSubscriptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const AttributeText = styled(Text)`
  font-weight: 400;
  font-size: 14px;
  padding-left: 34px;
  color: #323130;
  line-height: 20px;
`;

export const EOProtectedTextStyled = styled(Text)`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #605E5C;
  font-style: italic;
`;

export const KeyTagText = styled(Text)`
  margin-left: 4px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #646464;
`;

export const ApprovedTag = styled(Text)`
  margin-left: 6px;
  font-weight: 600;
  font-size: 11px;
  line-height: 16px;
  color: #107c10;
`;

export const AllApprovedBadge = styled(Text)`
  font-weight: 600;
  font-size: 11px;
  line-height: 16px;
  color: #107c10;
  background-color: #dff6dd;
  padding: 2px 6px;
  border-radius: 2px;
`;